module.exports = __webpack_public_path__ + "img/DHLNL.cdfa043d.png";